import { useContext } from 'react';
import api from "../API/api";
import { ConfigContext } from "../Components/App/App";
import { AppContext } from "../Components/App/AppContext";
import { ChatMessage } from "../Components/Shared/API/ApiTypes";

export function useMessageSender() {
  let tempLinks = ""
  let tempMessageString = ""
  const { state, dispatch } = useContext(AppContext);
  const config = useContext(ConfigContext);
  const handleResponseStream = (msg: any, msgType: string) => {
    try {
      if (msgType === "NewMessage") {
        if (msg.includes("(") || tempMessageString.includes("(")) {
          tempMessageString = tempMessageString + msg
          let parenIndex = tempMessageString.indexOf("(")
          if (parenIndex < (tempMessageString.length - 1) && tempMessageString[parenIndex + 1] !== "S") {
            let tempMessage: ChatMessage = { content: msg, direction: 1, time: new Date(Date.now()), temp: true };
            dispatch({ type: "updateTempMessage", message: tempMessage })
          }
        }
        else {
          let tempMessage: ChatMessage = { content: msg, direction: 1, time: new Date(Date.now()), temp: true };
          dispatch({ type: "updateTempMessage", message: tempMessage })
        }
      }
      if (msgType === "Links") {
        tempLinks = tempLinks + msg;
      }
      if (msgType === "Closed") {
        let links = JSON.parse(tempLinks);
        let newMessage: ChatMessage = { content: "", direction: 1, relatedLinks: links, time: new Date(Date.now()), temp: false };
        dispatch({ type: "updateTempMessage", message: newMessage })
        tempLinks = "";
      }
    }
    catch (e) {

    }
  }

  const messageFailed = () => {
    let newMessage: ChatMessage = { content: "Sorry, there was a problem finding an answer. You can try asking again.", direction: 1, time: new Date(Date.now()) };
    dispatch({ type: "addMessage", message: newMessage })
  }

  const sendMessage = async (message: ChatMessage) => {
    let messageCount = state.messages.length
    let startIndex = messageCount > 3 ? messageCount - 4 : 0;
    let lastMessages = state.messages.slice(startIndex, messageCount - 1)
    dispatch({ type: "addMessage", message })
    let tempMessage: ChatMessage = { content: "", direction: 1, time: new Date(Date.now()), temp: true };
    dispatch({ type: "addMessage", message: tempMessage })
    try {
      if (config.IndexName.includes("catalog")) {
        let result = await api.catalog.ask({ question: message.content, index: config.IndexName, context: lastMessages, sessionid: state.sessionid })
        if (result?.answer) {
          let newMessage: ChatMessage = { content: result.answer, direction: 1, time: new Date(Date.now()), relatedLinks: result.links, cards: result.cards };
          dispatch({ type: "addMessage", message: newMessage })
          dispatch({ type: "setContactInformationFromLinks", links: result.links, config: config })
        }
        else {
          messageFailed()
        }
      }
      else {
        try {
          await api.questionStream.ask({ question: message.content, index: config.IndexName, context: lastMessages, sessionid: state.sessionid }, handleResponseStream)
        }
        catch (e) {
          let result = await api.question.ask({ question: message.content, index: config.IndexName, context: lastMessages, sessionid: state.sessionid })
          if (result?.answer) {
            let newMessage: ChatMessage = { content: result.answer, direction: 1, time: new Date(Date.now()), relatedLinks: result.links, cards: result.cards };
            dispatch({ type: "addMessage", message: newMessage })
            dispatch({ type: "setContactInformationFromLinks", links: result.links, config: config })
          }
          else {
            messageFailed()
          }
        }

      }
    }
    catch {
      messageFailed()
    }
  }
  return sendMessage;
}
